<template>
    <container>
        <div class="ui segments raised">
            <CardTitle
                title="Listagem Tipo de Receita"
                titleClass="ui violet large ribbon label"
            >
            </CardTitle>
            <ContainerBody>
                <ValidationObserver ref="frmListagem" slim>
                      <div class="six wide column right aligned" style="height:25px;" >
                        <Button
                            title="Atualizar"
                            classIcon="icon refresh"
                            @click="filtrar"
                            position="right floated"
                            :disabled=false
                        />
                        <Button
                            title="Imprimir"
                            classIcon="icon print"
                            buttonColor="blue"
                            @click="print"
                            position="right floated"
                            :disabled=false
                        />
                    </div>
                </ValidationObserver>
            </ContainerBody>
            <ContainerBody id="printArea" name="printArea">
                 <div class="ui grid" style="margin: 5px;">
                     &nbsp;
                 </div>
                 <div class="table-scroll">
                    <v-data-table
                        :headers="tableHeaders"
                        :items="dataItems"
                        item-key="recnum"
                        dense
                        class="ui table very compact celled selectable dataTable" style="width: 100%; white-space: nowrap;"
                        :footer-props="{
                            showFirstLastPage: true,
                        }"
                    >
                      <template v-slot:item="{ item }">
                        <tr>
                          <td class="center aligned">{{item.codigo}}</td>
                          <td>{{item.descricao}}</td>
                          <td class="center aligned">{{item.aceitalanctos}}</td>
                          <td class="center aligned">{{item.aceitaestorno}}</td>
                        </tr>
                      </template>
                    </v-data-table>
                 </div>
            </ContainerBody>
        </div>
    </container>
</template>
<script>
import Container from '@/components/Container.vue';
import CardTitle from '@/components/CardTitle.vue';
import ContainerBody from '@/components/ContainerBody.vue';
import Button from '@/components/Button.vue';

import { ValidationObserver } from 'vee-validate';
import api from '@/services/api';
import numeral from 'numeral';
import 'numeral/locales/pt-br';

export default {
  name: 'TiposReceita',
  components: {
    Container,
    CardTitle,
    ContainerBody,
    ValidationObserver,
    Button,
  },
  data() {
    return {
      tableHeaders: [
        { text: 'Código', align: 'center aligned', value: 'codigo' },
        { text: 'Descrição', align: 'left aligned', value: 'descricao' },
        { text: 'Aceita Lançamentos', align: 'center aligned', value: 'aceitalanctos' },
        { text: 'Aceita Estorno', align: 'center aligned', value: 'aceitaestorno' },
      ],
      dataItems: [],
    };
  },
  mounted() {
    numeral.locale('pt-br');
    this.filtrar();
  },
  methods: {
    async filtrar() {
      this.$store.commit('global/loading');
      await api.get('/api/reports/Financeiro/tipo-receita')
        .then((result) => {
          this.dataItems = result.data.dados;
        });
      this.$store.commit('global/loaded');
    },
    print() {
      this.$htmlToPaper('printArea');
    },
  },
};
</script>
